<template>
 <div v-if="loader">
      <img
        src="../../../../assets/img/loader.svg"
        alt="loader"
        class="sa-loader sa-loader-top"
      />
    </div>
  <div v-else>
    <div class="sa-mob-cont ">
      <button class="sa-btn-back"  @click="$parent.referCovid=false">
        <i class="icon-arrow-left"></i>
      </button>
      <h6 class="sa-card-tit sa-ref-tit">Refer to Covid Test</h6>
      <div class="sa-physio-radio sa-radio-btn" v-for="(covid,i) in covidList" :key="i">
        <span
          ><input
            type="radio"
            :id="covid.pkg_id"
            v-model="selected"
            :name="covid.pkg_nm"
            :value="covid.pkg_id"
          />
          <label :for="covid.pkg_id" class="sa-mb30">{{covid.pkg_nm}}</label></span
        >
      </div>
    </div>
    <div class="sa-ftr-btn">
      <button :disabled="selected && selected.length <= 0" class="sa-btn sa-btn-large sa-btn-primary sa-btn-block-xs" @click="nextScreen">
        Continue
      </button>
    </div>
  </div>
</template>
<script>
import { pro_url } from "../../../../../config/endpoints";
import _ from "lodash"
export default {
    props: ['covid'],
    data(){
        return{
            covidList:[],
            selected:[],
            loader: false,
            //selectedCheck:false
        }
    },
    mounted () {
      this.selected = (this.covid && this.covid.length )? this.covid[0]: []
      this.getCovid()
    },
    methods: {
      getCovid () {
        let _self = this
         _self.loader = true;
        _self.$store.dispatch("httpPost", {
            uri: `${pro_url}/refer/treatmentDetails`,
            body: {
                "mtype": 5,  
                "limit": 1000,
                "page": 1,
                "name": _self.searchName,
                "prd_id":'ST041'
            }
            }).then(response => {
            if (response && response.status === 1000) {
              console.log(response,'responseresponseresponseresponse')
               _self.loader = false;
                _self.covidList = response.data.data 
                  // _.map(_self.covidList, e => {
                  //  // console.log(e.pkg_id);
                  //   if(e.pkg_id == _self.covid){
                  //     _self.selectPakage = e
                  //     return e
                  //   }
                  // })
            }
        })
      },
      nextScreen () {
        this.loading = true
        let _self = this
        _self.patDetails = JSON.parse(_self.$localStorage.get('patDetails'))
        _self.$store.dispatch('httpPost', {
            uri: `${pro_url}/refer/addTreatmentReferal`,
            body:{
            "apnt_id": _self.patDetails.apnt_id,
            // "pid": _self.patDetails.pid,
            "uid": _self.patDetails.refDoctor || "",
            stid: _self.patDetails.stid || '',
            dept_id: _self.patDetails.dept_id || '',
            "pkg_id": _self.patDetails.refPackages || [],
            "tsk_id": _self.patDetails.refNurse,
            "tst_id": _self.patDetails.refTests || [],
            "trtmnt_id": _self.patDetails.refPhysio || [],
            'radiology':  _self.patDetails.radiology || [],
            "vitamin_iv_drip": _self.patDetails.vitamin_iv_drip || [],
             "vaccination": _self.patDetails.vaccination || [],
            "hemodialysis":  _self.patDetails.hemodialysis || [],
            "covid":[_self.selected],
            ref_doctorId : _self.patDetails.ref_doctorId || ''
            }
        }).then(response => {

            _self.loading = false
            if (response && response.status === 1000) {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
                msg: "Referred COvid Tasks successfully",
                class: "sa-a-success"
            });
            this.$parent.referCovid = false
            this.$parent.getReferralData();
            } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
                msg: `${response.desc}. Something went wrong. Please try again or contact operations team`,
                class: "sa-a-danger"
            });
            }
        })      
    }
    }
}
</script>